export interface Country {
  code: string
  name: string
  dial: string
  flag: string
}

function flag(code: string): string {
  return [...code.toUpperCase()]
    .map((c) => String.fromCodePoint(0x1f1e6 - 65 + c.charCodeAt(0)))
    .join('')
}

function c(code: string, name: string, dial: string): Country {
  return { code, name, dial, flag: flag(code) }
}

export const countries: Country[] = [
  c('AF', 'Afghanistan', '+93'),
  c('AL', 'Albania', '+355'),
  c('DZ', 'Algeria', '+213'),
  c('AD', 'Andorra', '+376'),
  c('AO', 'Angola', '+244'),
  c('AR', 'Argentina', '+54'),
  c('AM', 'Armenia', '+374'),
  c('AU', 'Australia', '+61'),
  c('AT', 'Austria', '+43'),
  c('AZ', 'Azerbaijan', '+994'),
  c('BH', 'Bahrain', '+973'),
  c('BD', 'Bangladesh', '+880'),
  c('BY', 'Belarus', '+375'),
  c('BE', 'Belgium', '+32'),
  c('BJ', 'Benin', '+229'),
  c('BT', 'Bhutan', '+975'),
  c('BO', 'Bolivia', '+591'),
  c('BA', 'Bosnia and Herzegovina', '+387'),
  c('BW', 'Botswana', '+267'),
  c('BR', 'Brazil', '+55'),
  c('BN', 'Brunei', '+673'),
  c('BG', 'Bulgaria', '+359'),
  c('BF', 'Burkina Faso', '+226'),
  c('BI', 'Burundi', '+257'),
  c('KH', 'Cambodia', '+855'),
  c('CM', 'Cameroon', '+237'),
  c('CA', 'Canada', '+1'),
  c('CV', 'Cape Verde', '+238'),
  c('CF', 'Central African Republic', '+236'),
  c('TD', 'Chad', '+235'),
  c('CL', 'Chile', '+56'),
  c('CN', 'China', '+86'),
  c('CO', 'Colombia', '+57'),
  c('KM', 'Comoros', '+269'),
  c('CG', 'Congo', '+242'),
  c('CD', 'Congo (DRC)', '+243'),
  c('CR', 'Costa Rica', '+506'),
  c('CI', "Cote d'Ivoire", '+225'),
  c('HR', 'Croatia', '+385'),
  c('CU', 'Cuba', '+53'),
  c('CY', 'Cyprus', '+357'),
  c('CZ', 'Czech Republic', '+420'),
  c('DK', 'Denmark', '+45'),
  c('DJ', 'Djibouti', '+253'),
  c('DO', 'Dominican Republic', '+1'),
  c('EC', 'Ecuador', '+593'),
  c('EG', 'Egypt', '+20'),
  c('SV', 'El Salvador', '+503'),
  c('GQ', 'Equatorial Guinea', '+240'),
  c('ER', 'Eritrea', '+291'),
  c('EE', 'Estonia', '+372'),
  c('SZ', 'Eswatini', '+268'),
  c('ET', 'Ethiopia', '+251'),
  c('FJ', 'Fiji', '+679'),
  c('FI', 'Finland', '+358'),
  c('FR', 'France', '+33'),
  c('GA', 'Gabon', '+241'),
  c('GM', 'Gambia', '+220'),
  c('GE', 'Georgia', '+995'),
  c('DE', 'Germany', '+49'),
  c('GH', 'Ghana', '+233'),
  c('GR', 'Greece', '+30'),
  c('GT', 'Guatemala', '+502'),
  c('GN', 'Guinea', '+224'),
  c('GW', 'Guinea-Bissau', '+245'),
  c('GY', 'Guyana', '+592'),
  c('HT', 'Haiti', '+509'),
  c('HN', 'Honduras', '+504'),
  c('HK', 'Hong Kong', '+852'),
  c('HU', 'Hungary', '+36'),
  c('IS', 'Iceland', '+354'),
  c('IN', 'India', '+91'),
  c('ID', 'Indonesia', '+62'),
  c('IR', 'Iran', '+98'),
  c('IQ', 'Iraq', '+964'),
  c('IE', 'Ireland', '+353'),
  c('IL', 'Israel', '+972'),
  c('IT', 'Italy', '+39'),
  c('JM', 'Jamaica', '+1'),
  c('JP', 'Japan', '+81'),
  c('JO', 'Jordan', '+962'),
  c('KZ', 'Kazakhstan', '+7'),
  c('KE', 'Kenya', '+254'),
  c('KW', 'Kuwait', '+965'),
  c('KG', 'Kyrgyzstan', '+996'),
  c('LA', 'Laos', '+856'),
  c('LV', 'Latvia', '+371'),
  c('LB', 'Lebanon', '+961'),
  c('LS', 'Lesotho', '+266'),
  c('LR', 'Liberia', '+231'),
  c('LY', 'Libya', '+218'),
  c('LI', 'Liechtenstein', '+423'),
  c('LT', 'Lithuania', '+370'),
  c('LU', 'Luxembourg', '+352'),
  c('MO', 'Macao', '+853'),
  c('MG', 'Madagascar', '+261'),
  c('MW', 'Malawi', '+265'),
  c('MY', 'Malaysia', '+60'),
  c('MV', 'Maldives', '+960'),
  c('ML', 'Mali', '+223'),
  c('MT', 'Malta', '+356'),
  c('MR', 'Mauritania', '+222'),
  c('MU', 'Mauritius', '+230'),
  c('MX', 'Mexico', '+52'),
  c('MD', 'Moldova', '+373'),
  c('MC', 'Monaco', '+377'),
  c('MN', 'Mongolia', '+976'),
  c('ME', 'Montenegro', '+382'),
  c('MA', 'Morocco', '+212'),
  c('MZ', 'Mozambique', '+258'),
  c('MM', 'Myanmar', '+95'),
  c('NA', 'Namibia', '+264'),
  c('NP', 'Nepal', '+977'),
  c('NL', 'Netherlands', '+31'),
  c('NZ', 'New Zealand', '+64'),
  c('NI', 'Nicaragua', '+505'),
  c('NE', 'Niger', '+227'),
  c('NG', 'Nigeria', '+234'),
  c('MK', 'North Macedonia', '+389'),
  c('NO', 'Norway', '+47'),
  c('OM', 'Oman', '+968'),
  c('PK', 'Pakistan', '+92'),
  c('PA', 'Panama', '+507'),
  c('PG', 'Papua New Guinea', '+675'),
  c('PY', 'Paraguay', '+595'),
  c('PE', 'Peru', '+51'),
  c('PH', 'Philippines', '+63'),
  c('PL', 'Poland', '+48'),
  c('PT', 'Portugal', '+351'),
  c('PR', 'Puerto Rico', '+1'),
  c('QA', 'Qatar', '+974'),
  c('RO', 'Romania', '+40'),
  c('RU', 'Russia', '+7'),
  c('RW', 'Rwanda', '+250'),
  c('SA', 'Saudi Arabia', '+966'),
  c('SN', 'Senegal', '+221'),
  c('RS', 'Serbia', '+381'),
  c('SL', 'Sierra Leone', '+232'),
  c('SG', 'Singapore', '+65'),
  c('SK', 'Slovakia', '+421'),
  c('SI', 'Slovenia', '+386'),
  c('SO', 'Somalia', '+252'),
  c('ZA', 'South Africa', '+27'),
  c('KR', 'South Korea', '+82'),
  c('SS', 'South Sudan', '+211'),
  c('ES', 'Spain', '+34'),
  c('LK', 'Sri Lanka', '+94'),
  c('SD', 'Sudan', '+249'),
  c('SR', 'Suriname', '+597'),
  c('SE', 'Sweden', '+46'),
  c('CH', 'Switzerland', '+41'),
  c('SY', 'Syria', '+963'),
  c('TW', 'Taiwan', '+886'),
  c('TJ', 'Tajikistan', '+992'),
  c('TZ', 'Tanzania', '+255'),
  c('TH', 'Thailand', '+66'),
  c('TL', 'Timor-Leste', '+670'),
  c('TG', 'Togo', '+228'),
  c('TN', 'Tunisia', '+216'),
  c('TR', 'Turkey', '+90'),
  c('TM', 'Turkmenistan', '+993'),
  c('UG', 'Uganda', '+256'),
  c('UA', 'Ukraine', '+380'),
  c('AE', 'United Arab Emirates', '+971'),
  c('GB', 'United Kingdom', '+44'),
  c('US', 'United States', '+1'),
  c('UY', 'Uruguay', '+598'),
  c('UZ', 'Uzbekistan', '+998'),
  c('VE', 'Venezuela', '+58'),
  c('VN', 'Vietnam', '+84'),
  c('YE', 'Yemen', '+967'),
  c('ZM', 'Zambia', '+260'),
  c('ZW', 'Zimbabwe', '+263'),
]

export const defaultCountryCode = 'FR'
